var map = {
	"./broadcaster.svg": 47775,
	"./default_subscriber.svg": 31181,
	"./founder.svg": 14194,
	"./moderator.svg": 74354,
	"./og.svg": 32915,
	"./staff.svg": 23085,
	"./sub_gift_1.svg": 76018,
	"./sub_gift_100.svg": 51490,
	"./sub_gift_200.svg": 59577,
	"./sub_gift_25.svg": 99006,
	"./sub_gift_50.svg": 34962,
	"./verified.svg": 23885,
	"./vip.svg": 98690
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38841;